import { Component } from '@angular/core';

@Component({
  selector: 'app-first-mfa-setup-page',
  templateUrl: './first-mfa-setup-page.component.html'
})
export class FirstMfaSetupPageComponent {
}
